import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { Media } from '@digilize/shared/definitions/src';
import { addWebp, isFileSizeCorrect, isImgSizeCorrect, isTotalSizeCorrect } from '@digilize/shared/utils/helpers/src';

@Component({
  selector: 'lib-photo-upload-list',
  templateUrl: './photo-upload-list.component.html',
  styleUrls: ['./photo-upload-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class PhotoUploadListComponent implements OnInit {
  @Output() filesChange: EventEmitter<File[]> = new EventEmitter<File[]>();
  @Output() mediaRemoved: EventEmitter<Media> = new EventEmitter<Media>();
  @Output() mediaSetAsFirst: EventEmitter<Media> = new EventEmitter<Media>();
  @Input() maxItems = 10;
  @Input() maxFileSize = 20; // Mb
  /* Every file goes in one multipart request, so the batch has its own ceiling. See isTotalSizeCorrect. */
  @Input() maxTotalSize = 28; // Mb
  @Input() maxImgRes = 8192; // px;
  /* CSS width of the largest tile. Drives the resized URL only. */
  @Input() previewWidth = 240; // px
  @Input() images: Array<Media> = [];
  @Input() fileTypesString = '.jpg,.png,.jpeg';
  @Input() fileNoteKey = 'upload.upload_file_note';
  @Input() showImgNote = true;

  loading = false;
  error: string;
  dragOver = false;
  constructor() {}

  ngOnInit() {}
  onFileChange($event) {
    this.handleFiles($event.target.files);
  }

  onDragOver(event: DragEvent) {
    // Without preventDefault the browser refuses the drop (and navigates to the file on drop).
    event.preventDefault();
    event.stopPropagation();
    this.dragOver = true;
  }

  onDragLeave(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.dragOver = false;
  }

  onFilesDropped(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.dragOver = false;

    // The hidden input's `accept` does not apply to drops - filter by extension ourselves.
    const accepted = this.fileTypesString.split(',').map((ext) => ext.trim().toLowerCase());
    const files = [...(event.dataTransfer?.files ?? [])].filter((file) =>
      accepted.some((ext) => file.name.toLowerCase().endsWith(ext))
    );

    if (files.length) {
      this.handleFiles(files);
    }
  }

  /**
   * The tile shows the whole image (`background-size: contain`), so this asks for Crop rather than
   * Cover: `m=3` would centre-crop an image the operator is here to check.
   */
  previewUrl(url: string): string {
    if (!url) {
      return url;
    }

    const size = Math.round(this.previewWidth * 2);

    return `${url}${url.includes('?') ? '&' : '?'}w=${size}&h=${size}&m=2${addWebp()}`;
  }

  private handleFiles(files: File[] | FileList) {
    this.error = null;

    if (!isTotalSizeCorrect(files, this.maxTotalSize)) {
      this.error = 'batch_too_big';
      return;
    }

    const filesToUpload: File[] = [];
    if (this.maxItems >= (this.images?.length || 0) + files.length) {
      [...files].forEach((file, index) => {
        if (!isFileSizeCorrect(file, this.maxFileSize)) {
          /*  this.error = 'file_too_big'; */
        } else {
          isImgSizeCorrect(file, this.maxImgRes, (callback) => {
            if (callback) {
              this.loading = true;
              filesToUpload.push(file);
              if (index === files.length - 1) {
                this.filesChange.emit(filesToUpload);
              }
            } else {
              /* this.error = 'img_too_big'; */
            }
          });
        }
      });
    } else {
      /*   this.error = 'too_many_files'; */
    }
  }
  upload(file) {
    /*
   move to parent
   this.mediaApiService.uploadFile(file).subscribe(
      (event) => {
        if (event instanceof HttpResponse) {
          this.items.push(event.body[0]);
          this.filesChange.emit(this.items);

          this.loading = false;
        }
      },
      (err) => {
        this.loading = false;
      }
    ); */
  }

  setAsFirst(item: Media) {
    this.mediaSetAsFirst.emit(item);
  }
  removeImage(item: Media) {
    this.mediaRemoved.emit(item);
  }
}
